import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders  } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {

constructor(
  private http: HttpClient,
) { }


getStudentDetails(){

  console.log("Getting Student Details")
 // return this.http.get('/assets/student.json');  
  return this.http.get('https://api.studydse.net/api/get_student_list.php',{withCredentials: true});  
}

getSchoolMCStat(){
  console.log("Getting School MC Stat")
 // return this.http.get('/assets/school_mc_stat.json');  
  return this.http.get('https://api.studydse.net/api/get_school_mc_stat.php',{withCredentials: true});  
}
getStudentMCActivities(){
  console.log("Getting Student MC Activities")
 // return this.http.get('/assets/student_activities.json');  
  return this.http.get('https://api.studydse.net/api/get_student_activities.php',{withCredentials: true});  
}

getTopicVSHK(){

  return this.http.get('https://api.studydse.net/api/get_topicVSHK.php',{withCredentials: true});  
}



getMCDetailsAnalysis(){
  console.log("Getting MC Details")
  
  return this.http.get('/assets/mc_details.json',);  
 // return this.http.get('../api/get_details_mc_analysis.php');  
}
}
